<template>
  <div class="relative w-full h-full bg-neutral-25 border border-border-normal overflow-hidden pointer-events-none" 
  style="height: 328px; border-radius: 20px;">
    <!-- Agency Preview Card -->
    <div class="agency-preview-card flex flex-col px-1.5 pt-1.5 pb-1" style="width: 280px;">
      <div class="w-full flex flex-col gap-5 bg-neutral-25 p-3">
        <div class="w-full flex justify-between items-start">
          <img src="https://publicassets.foreplay.co/agency-directory-preview-avatars/soar-with-us.png" class="rounded-md" style="width: 52px; height: 52px;" >
          <ForeplayAgencyLogo />
        </div>
        <div class="w-full flex flex-col gap-0.5">
          <div class="agency-name text-text-muted">
            Soar with Us
          </div>
          <div class="flex items-center p-1 gap-1">
            <VerifiedBadgeIcon />
            <BaseText type="label" size="xs" class="text-text-muted">
              Verified Agency
            </BaseText>
          </div>
        </div>
      </div>
      <div class="w-full grid grid-cols-2 gap-2.5 p-3 mt-1.5">
        <div class="col-span-2 w-full flex items-center justify-center p-1.5 rounded-lg border border-border-normal">
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <g opacity="0.68">
              <path d="M15.8423 9.45812C15.8423 12.9841 12.984 15.8424 9.45809 15.8424M15.8423 9.45812C15.8423 5.9322 12.984 3.07388 9.45809 3.07388M15.8423 9.45812H3.07385M9.45809 15.8424C5.93217 15.8424 3.07385 12.9841 3.07385 9.45812M9.45809 15.8424C7.89101 15.8424 6.62065 12.9841 6.62065 9.45812C6.62065 5.9322 7.89101 3.07388 9.45809 3.07388M9.45809 15.8424C11.0251 15.8424 12.2955 12.9841 12.2955 9.45812C12.2955 5.9322 11.0251 3.07388 9.45809 3.07388M9.45809 3.07388C5.93217 3.07388 3.07385 5.9322 3.07385 9.45812" stroke="#343642" stroke-width="1.18227" stroke-linecap="square"/>
            </g>
          </svg>
          <BaseText type="label" size="sm" class="text-text-loud px-1">
            Visit Website
          </BaseText>
        </div>
        <div class="w-full flex items-center justify-center p-1.5 rounded-lg border border-border-normal">
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <g opacity="0.68">
              <path d="M14.1282 14.0098V14.837H4.78833V14.0098H14.1282ZM3.53149 13.3008C3.62897 13.6178 3.87961 13.8673 4.19653 13.9649V14.8106C3.42188 14.6846 2.81169 14.0756 2.68579 13.3008H3.53149ZM16.2297 13.3008C16.1038 14.0757 15.4939 14.6848 14.719 14.8106V13.9659C15.0363 13.8685 15.2864 13.618 15.384 13.3008H16.2297ZM16.2561 12.709H15.429V8.30475L16.2561 7.89166V12.709ZM3.48755 8.30573V12.709H2.6604V7.89166L3.48755 8.30573ZM10.0012 10.3282C9.64681 10.4384 9.26869 10.4385 8.91431 10.3282L9.29321 9.57037C9.40239 9.58856 9.51313 9.58849 9.62231 9.57037L10.0012 10.3282ZM8.74341 9.34772L8.37427 10.088L4.07837 7.94049V7.01471L8.74341 9.34772ZM14.8372 7.94049L10.5413 10.088L10.3567 9.71783L10.1711 9.34772L14.8372 7.01569V7.94049ZM3.48755 7.64459L3.15259 7.4776L3.48755 6.80865V7.64459ZM15.762 7.4776L15.429 7.64459V6.80865L15.762 7.4776ZM3.12817 6.20709L3.1272 6.20905L2.6604 7.14166V6.20709H3.12817ZM16.2561 6.20709V7.14166L15.7893 6.20905L15.7883 6.20709H16.2561ZM14.719 4.10455C15.494 4.23028 16.1037 4.84045 16.2297 5.6153H15.384C15.2864 5.29806 15.0364 5.04661 14.719 4.94928V4.10455ZM4.19653 4.95026C3.8795 5.0478 3.62904 5.29827 3.53149 5.6153H2.68579C2.81176 4.84061 3.42185 4.23052 4.19653 4.10455V4.95026ZM14.1282 4.07916V4.90631H4.78833V4.07916H14.1282Z" fill="#303546" stroke="#303546" stroke-width="0.591133"/>
            </g>
          </svg>
          <BaseText type="label" size="sm" class="text-text-muted px-1">
            Contact
          </BaseText>
        </div>
        <div class="w-full flex items-center justify-center p-1.5 rounded-lg border border-border-normal">
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <g opacity="0.68">
              <path d="M15.4877 2.36459H3.42854C3.14634 2.36459 2.8757 2.4767 2.67616 2.67625C2.4766 2.87579 2.3645 3.14643 2.3645 3.42863V15.4877C2.3645 15.7699 2.4766 16.0406 2.67616 16.2401C2.8757 16.4397 3.14634 16.5518 3.42854 16.5518H15.4877C15.7698 16.5518 16.0405 16.4397 16.24 16.2401C16.4396 16.0406 16.5517 15.7699 16.5517 15.4877V3.42863C16.5517 3.14643 16.4396 2.87579 16.24 2.67625C16.0405 2.4767 15.7698 2.36459 15.4877 2.36459ZM6.62066 14.4237H4.49258V8.03947H6.62066V14.4237ZM5.55662 6.79809C5.31273 6.79112 5.0763 6.71243 4.87688 6.57186C4.67746 6.43129 4.52387 6.23506 4.43534 6.00771C4.34679 5.78035 4.32721 5.53194 4.37904 5.29352C4.43087 5.0551 4.55181 4.83723 4.72675 4.66716C4.90169 4.49708 5.12287 4.38232 5.36266 4.33723C5.60244 4.29213 5.8502 4.3187 6.07497 4.41361C6.29975 4.50851 6.49157 4.66756 6.62647 4.87086C6.76137 5.07417 6.83336 5.31272 6.83347 5.55671C6.82786 5.89036 6.69041 6.20822 6.45116 6.44083C6.2119 6.67344 5.8903 6.80189 5.55662 6.79809ZM14.4236 14.4237H12.2955V11.0613C12.2955 10.0541 11.8699 9.69228 11.3166 9.69228C11.1544 9.70308 10.9959 9.7458 10.8503 9.81807C10.7046 9.89027 10.5746 9.9906 10.4678 10.1132C10.3611 10.2358 10.2795 10.3783 10.228 10.5325C10.1764 10.6866 10.1559 10.8495 10.1675 11.0117C10.1639 11.0447 10.1639 11.078 10.1675 11.111V14.4237H8.03938V8.03947H10.0965V8.96164C10.304 8.64597 10.5891 8.38887 10.9245 8.215C11.2599 8.04113 11.6343 7.95624 12.0118 7.96853C13.1113 7.96853 14.3952 8.57858 14.3952 10.5648L14.4236 14.4237Z" fill="#303546"/>
            </g>
          </svg>
          <BaseText type="label" size="sm" class="text-text-muted px-1">
            LinkedIn
          </BaseText>
        </div>
      </div>
    </div>
    <!-- Agency Preview Logos -->
    <div class="logo-previews-1 flex items-center gap-3">
      <img src="https://publicassets.foreplay.co/agency-directory-preview-avatars/ogilvy.jpg" class="rounded-2xl" style="width: 72px; height: 72px;">
      <img src="https://publicassets.foreplay.co/agency-directory-preview-avatars/h.png" class="rounded-2xl" style="width: 72px; height: 72px;">
    </div>
    <div class="logo-previews-2 flex items-center gap-3">
      <img src="https://publicassets.foreplay.co/agency-directory-preview-avatars/ctc.jpg" class="rounded-2xl" style="width: 72px; height: 72px;">
      <img src="https://publicassets.foreplay.co/agency-directory-preview-avatars/power.png" class="rounded-2xl" style="width: 72px; height: 72px;">
    </div>
    <!-- Overlay Gradient -->
  </div>
</template>

<script>
import ForeplayAgencyLogo from '../../../globals/Icons/AgencyIcons/ForeplayAgencyLogo.vue'
import VerifiedBadgeIcon from '../../../globals/Icons/AgencyIcons/VerifiedBadgeIcon.vue'

export default {
  name: 'AgencyCreatePreview',
  components: {
    ForeplayAgencyLogo,
    VerifiedBadgeIcon
  }
}
</script>

<style scoped>
.agency-preview-card {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  box-shadow: 0 48px 48px -32px rgba(47, 53, 71, 0.08), 0 40px 40px -24px rgba(47, 53, 71, 0.08), 0 24px 24px -12px rgba(47, 53, 71, 0.08), 0 12px 12px -8px rgba(47, 53, 71, 0.08), 0 4px 4px -3px rgba(47, 53, 71, 0.08);
  z-index: 100;
}
.agency-name {
  font-size: 15.764px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.069px; /* 140% */
  letter-spacing: -0.087px;
}
.logo-previews-1 {
  position: absolute;
  bottom: 120px;
  left: calc(50% - 210px);
  transform: translateX(-50%);
}
.logo-previews-2 {
  position: absolute;
  bottom: 120px;
  right: calc(50% - 210px);
  transform: translateX(50%);
}
</style>